/* Tabigami product photo zoom: tap/click the main photo to open it full screen.
   Phones: swipe between photos, pinch to zoom. Computers: click to zoom in, move the mouse to look around. */
(function () {
  'use strict';
  var main = document.querySelector('main[data-template^="product"] .main-image img');
  if (!main) return;
  var holder = main.closest('.main-image');
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (!m) return;

  var images = null;
  function big(src) {
    if (!src) return src;
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    try { var url = new URL(u, location.origin); url.searchParams.set('width', '2000'); return url.toString(); } catch (e) { return u; }
  }
  function loadImages() {
    if (images) return Promise.resolve(images);
    return fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) { images = (p.images || []).map(big); if (!images.length) images = [big(main.src)]; return images; })
      .catch(function () { images = [big(main.src)]; return images; });
  }

  holder.classList.add('tg-zoomable');
  var hint = document.createElement('span');
  hint.className = 'tg-zoom-hint';
  hint.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4M11 8v6M8 11h6"/></svg><span>Tap to zoom</span>';
  holder.appendChild(hint);

  var box, stage, img, counter, idx = 0, zoomed = false;
  function build() {
    box = document.createElement('div');
    box.className = 'tg-zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product photos');
    box.innerHTML =
      '<button type="button" class="tg-zoom__x" aria-label="Close">×</button>' +
      '<button type="button" class="tg-zoom__nav tg-zoom__prev" aria-label="Previous photo">‹</button>' +
      '<div class="tg-zoom__stage"><img alt=""></div>' +
      '<button type="button" class="tg-zoom__nav tg-zoom__next" aria-label="Next photo">›</button>' +
      '<div class="tg-zoom__bar"><span class="tg-zoom__count"></span><span class="tg-zoom__tip"></span></div>';
    document.body.appendChild(box);
    stage = box.querySelector('.tg-zoom__stage');
    img = stage.querySelector('img');
    counter = box.querySelector('.tg-zoom__count');
    box.querySelector('.tg-zoom__tip').textContent = window.matchMedia('(hover: hover)').matches ? 'Click the photo to zoom in' : 'Pinch to zoom · swipe for more';
    box.querySelector('.tg-zoom__x').addEventListener('click', close);
    box.querySelector('.tg-zoom__prev').addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    box.querySelector('.tg-zoom__next').addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target === stage) close(); });

    // computers: click to zoom, move to pan
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!window.matchMedia('(hover: hover)').matches) return;
      zoomed = !zoomed;
      stage.classList.toggle('is-zoomed', zoomed);
      pan(e);
    });
    img.addEventListener('mousemove', function (e) { if (zoomed) pan(e); });

    // phones: swipe left/right (one finger only, so pinch still works)
    var sx = null, sy = null;
    stage.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } else { sx = null; } }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null || (window.visualViewport && window.visualViewport.scale > 1.05)) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      sx = null;
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!box || box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });
  }
  function pan(e) {
    var r = img.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
    img.style.transformOrigin = Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
  }
  function show() {
    zoomed = false;
    stage.classList.remove('is-zoomed');
    img.src = images[idx];
    counter.textContent = images.length > 1 ? (idx + 1) + ' / ' + images.length : '';
    box.classList.toggle('is-single', images.length < 2);
  }
  function go(d) { if (!images || images.length < 2) return; idx = (idx + d + images.length) % images.length; show(); }
  function open() {
    loadImages().then(function () {
      if (!box) build();
      // start on the photo that's showing
      var cur = (main.currentSrc || main.src).split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '');
      idx = Math.max(0, images.findIndex(function (s) { return s.split('?')[0].split('/').pop() === cur; }));
      show();
      box.hidden = false;
      document.documentElement.classList.add('tg-zoom-open');
      box.querySelector('.tg-zoom__x').focus({ preventScroll: true });
      try { if (typeof window.gtag === 'function') window.gtag('event', 'product_photo_zoom', { item_id: m[1] }); } catch (e) {}
    });
  }
  function close() {
    if (!box) return;
    box.hidden = true;
    document.documentElement.classList.remove('tg-zoom-open');
  }
  holder.addEventListener('click', function (e) {
    if (e.target.closest('.tg-heart')) return;
    open();
  });
})();
